export default "__VITE_ASSET__DLzoNZuT__"